import {Company} from "../types/domain/company";

export const MADERA_PARENT_COMPANY = "54089edd-611c-41f0-895e-1c1913786d5a";

/**
 * Checks if a given company belongs to Madera organization.
 */
export const isMaderaCompany = (company: Company) =>
    company.parentCompaniesIds.includes(MADERA_PARENT_COMPANY) || company.id === MADERA_PARENT_COMPANY;

export const MaderaStartYear = 2021;
